// GetPageMetaData returns the meta data about a given path.
export const NotFoundMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then((m) => m.NotFoundMetaService_GetPageMetaData);
NotFoundMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.not_found_page.v1.meta.NotFoundMetaService/GetPageMetaData" as const;
